<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-RightSmall`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.17527 13.7496C5.44874 14.0228 5.89187 14.0226 6.16503 13.7491L11.317 8.5914C11.3556 8.56563 11.3922 8.5357 11.4262 8.50161C11.7042 8.22287 11.7036 7.77154 11.4248 7.49354L6.18053 2.2632C5.90179 1.9852 5.45046 1.9858 5.17246 2.26454C4.89446 2.54328 4.89506 2.99461 5.1738 3.2726L9.92159 8.00776L5.17473 12.7599C4.90156 13.0333 4.90181 13.4765 5.17527 13.7496Z" :fill="useCurrentColor ? 'currentColor' : '#333'"/></svg>
</template>
<script>

export default {
  name: 'IconRightSmall',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
